import React, { Fragment } from "react"

import { Field, useFormikContext } from "formik"
import { getInNested } from "../dynamic-form.helper"

function InputSelect(props) {
  const { id, label, name, optionData, selectedValue, errorMessage, fieldData, isNestedFieldName, isRequired, ...otherProps } = props
  const normalizedNameKey = isNestedFieldName ? name : `['${name}']`
  const { errors, touched } = useFormikContext()
  return (
    <Fragment>
      <div className="form-block-wrapper">
        <fieldset disabled={fieldData.enabled === false}>
          <div className="custom-form-block flex-grow-1">
            <label htmlFor={id} className="form-label">
              {label} {isRequired && <sup>*</sup>}
            </label>
            <div className="input-group has-validation">
              <Field as="select" name={normalizedNameKey} id={id} className={`form-select`} defaultValue={selectedValue} {...otherProps}>
                {optionData &&
                  Array.isArray(optionData) &&
                  optionData.map((option, option_index) => (
                    <option value={option.value} key={`${name}-option-${option_index}`}>
                      {option.display}
                    </option>
                  ))}
              </Field>
            </div>
            {fieldData?.helper ? <div className="field-helper">{fieldData.helper}</div> : null}
            <div className="invalid-feedback">
              {getInNested(touched, name, isNestedFieldName) && getInNested(errors, name, isNestedFieldName) ? errorMessage : ""}
            </div>
          </div>
        </fieldset>
      </div>
    </Fragment>
  )
}

InputSelect.propTypes = {}

export default InputSelect
